/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KS_customerservice_Service_Clients_Connect_AdminTenantDto } from '../models/KS_customerservice_Service_Clients_Connect_AdminTenantDto';
import type { KS_customerservice_Service_Clients_Connect_CompanyAdminDto } from '../models/KS_customerservice_Service_Clients_Connect_CompanyAdminDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConnectService {

    /**
     * @param tenantId 
     * @param tenantName 
     * @param tenantCode 
     * @param companyId 
     * @param companyName 
     * @param companyTaxNumber 
     * @param isActive 
     * @param skip 
     * @param top 
     * @returns KS_customerservice_Service_Clients_Connect_CompanyAdminDto OK
     * @throws ApiError
     */
    public static getApiConnectCompanies(
tenantId?: string,
tenantName?: string,
tenantCode?: number,
companyId?: string,
companyName?: string,
companyTaxNumber?: string,
isActive?: boolean,
skip?: number,
top?: number,
): CancelablePromise<Array<KS_customerservice_Service_Clients_Connect_CompanyAdminDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connect/companies',
            query: {
                'TenantId': tenantId,
                'TenantName': tenantName,
                'TenantCode': tenantCode,
                'CompanyId': companyId,
                'CompanyName': companyName,
                'CompanyTaxNumber': companyTaxNumber,
                'IsActive': isActive,
                'Skip': skip,
                'Top': top,
            },
        });
    }

    /**
     * @param id 
     * @returns void 
     * @throws ApiError
     */
    public static deleteApiConnectCompanies(
id: string,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/connect/companies/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id 
     * @param tenantId 
     * @returns void 
     * @throws ApiError
     */
    public static patchApiConnectCompaniesInactivate(
id: string,
tenantId?: string,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connect/companies/{id}/inactivate',
            path: {
                'id': id,
            },
            headers: {
                'tenantId': tenantId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param id 
     * @param tenantId 
     * @returns void 
     * @throws ApiError
     */
    public static patchApiConnectCompaniesActivate(
id: string,
tenantId?: string,
): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/connect/companies/{id}/activate',
            path: {
                'id': id,
            },
            headers: {
                'tenantId': tenantId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param select Returns only the selected properties. (ex. FirstName, LastName, City)
     * @param expand Include only the selected objects. (ex. Childrens, Locations)
     * @param filter Filter the response with OData filter queries.
     * @param top Number of objects to return. (ex. 25)
     * @param skip Number of objects to skip in the current order (ex. 50)
     * @param orderby Define the order by one or more fields (ex. LastModified)
     * @returns KS_customerservice_Service_Clients_Connect_AdminTenantDto OK
     * @throws ApiError
     */
    public static getApiConnectTenants(
select?: string,
expand?: string,
filter?: string,
top?: string,
skip?: string,
orderby?: string,
): CancelablePromise<Array<KS_customerservice_Service_Clients_Connect_AdminTenantDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/connect/tenants',
            query: {
                '$select': select,
                '$expand': expand,
                '$filter': filter,
                '$top': top,
                '$skip': skip,
                '$orderby': orderby,
            },
        });
    }

}
